import { createAction, props } from '@ngrx/store';

export const TellentSecureChangeActions = {
  sendCode: createAction('[TellentSecureChange] sendCode'),
  sendCodeSuccess: createAction('[TellentSecureChange] sendCodeSuccess'),
  sendCodeFail: createAction('[TellentSecureChange] sendCodeFail'),

  validateCode: createAction('[TellentSecureChange] validateCode', props<{ code: string }>()),
  validateCodeSuccess: createAction(
    '[TellentSecureChange] validateCodeSuccess',
    props<{ ok: true }>(),
  ),
  validateCodeFail: createAction(
    '[TellentSecureChange] validateCodeFail',
    props<{ ok: false; error: string }>(),
  ),
};
